import Footer from '../global/components/Footer';
import Header from '../global/components/Header';
import Container from '@mui/material/Container';
import NicuFilterableList from './components/NicuFilterableList';

//This function creates nicu application.
export default function NicApp() {
 
    return (
    <>
        <Header message={"NICU Search"} />
        <Container maxWidth={false}>
            <NicuFilterableList/>
        </Container>
        <Footer/>
    </>
    );
}